export default function AffiliateDisclosure() {
  return (
    <div className="disclosure" role="note" aria-label="Affiliate disclosure">
      <span>ℹ️</span>
      <p>
        <strong>Affiliate Disclosure:</strong> This page contains affiliate links.
        As an Amazon Associate I earn from qualifying purchases — at no extra cost to you.
        We only recommend products we genuinely believe in.
      </p>
    </div>
  );
}
